// extracted by mini-css-extract-plugin
export default {"container":"RoleVerification_container__-Y4PF"};